module.exports = __webpack_public_path__ + "static/media/menu.bec96314.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/home-navbar/menu.svg
// module id = 403
// module chunks = 0 1 2